"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_INVOKE_ENERGY = void 0;
exports.DEFAULT_INVOKE_ENERGY = 1000000n;
